import React from "react";

import ModalAddUserProjectUsersRow from "./project-users-row";

import Classes from "classnames";

export default function ModalAddUserProjectUsers(props) {
    if (!props.projectUsers) return false;

    const onUserClick = (userId, e) => {props.onUserClick(userId, 'project', e);}

    const selectedArr = props.selected.map(obj=>obj.userId)

    const listClasses = Classes('ui5-manage-list','users-with-access',{
        'multiselect': props.multiselect
    });

    return (

        <div className={listClasses}>
            {props.projectUsers.map((pu, key)=>
                <ModalAddUserProjectUsersRow key={key}
                                             user={pu.user}
                                             multiselect={props.multiselect}
                                             isSelected={props.multiselect && selectedArr.includes(pu.user.id)}
                                             onClick={onUserClick}/>)}
        </div>
    )
}